var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapsPinNoAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 38,
    viewBox: "0 0 22 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_728_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.18242 3.94954C1.59132 5.64764 0.594714 8.12129 0.633412 10.448C0.714221 15.3102 2.90585 17.1508 6.41067 23.8426C7.67317 26.7873 8.99085 29.9032 10.2441 35.0637C10.4182 35.8249 10.5881 36.532 10.6667 36.5933C10.7452 36.6546 10.9151 35.945 11.0893 35.1838C12.3425 30.0232 13.6601 26.9099 14.9226 23.9652C18.4275 17.2733 20.6191 15.4327 20.6999 10.5705C20.7386 8.24379 19.7395 5.76766 18.1484 4.06956C16.3309 2.12977 13.5894 0.694173 10.6667 0.634142C7.74392 0.574072 4.99999 2.00974 3.18242 3.94954Z",
    fill: "#0B6985",
    stroke: "#052D39",
    strokeWidth: 1.26462
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 14.4675C12.7868 14.4675 14.5055 12.7489 14.5055 10.6288C14.5055 8.50867 12.7868 6.79001 10.6667 6.79001C8.54658 6.79001 6.82788 8.50867 6.82788 10.6288C6.82788 12.7489 8.54658 14.4675 10.6667 14.4675Z",
    fill: "#052D39"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_728_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 37.2185,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsPinNoAnswer);
export default __webpack_public_path__ + "static/media/maps-pin-NoAnswer.c37a5dee011dfb4d73ca69e171b631b2.svg";
export { ForwardRef as ReactComponent };